import { useAuth0 } from '@auth0/auth0-react';
import { Button, Col, Divider, Row } from 'antd';
import { useEffect, useState } from 'react';
import SectionPage from '../../components/section/SectionPage';
import { UserClaimsWithTSDB } from '../../types/userType';
import FilterDatabase from './FilterDatabase';
import DataSourcesHome from './routesHome/DataSourcesHome';
import SavedSessionsHome from './routesHome/SavedSessionsHome';
import SqliteHome from './routesHome/SqliteHome';
import { Link } from 'react-router-dom';
import { AppRoute } from '../../routes';

export const HomePage: React.FC = () => {
  const { user, isAuthenticated } = useAuth0();
  const [userInfo, setUserInfo] = useState<UserClaimsWithTSDB | null>(null);

  useEffect(() => {
    if (!user || !isAuthenticated) setUserInfo(null);
    else setUserInfo(user as UserClaimsWithTSDB);
  }, [isAuthenticated, user]);

  return (
    <>
      <SectionPage backgroundColor="transparent" boxShadow={false} paddingTop={0}>
        <SectionPage id="sectionHome" boxShadow={false} paddingTop={50} paddingBottom={50} height="70vh" heightBody="100%">
          <Row style={{ height: '100%' }} align="middle" justify="space-between">
            <Col></Col>
            <Col span={24} md={10} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <h1 style={{ fontSize: 24, fontWeight: 'bold', marginBottom: 30 }}>Select your database (NeOse Advance)</h1>
              <p style={{ marginBottom: 30 }}>Choose the database where the data you want to analyze are contained</p>
              <FilterDatabase userInfo={userInfo} />
            </Col>
            <Divider type={'vertical'} style={{ height: 'auto', alignSelf: 'stretch' }}></Divider>
            <Col span={24} md={10} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <h1 style={{ fontSize: 24, fontWeight: 'bold', marginBottom: 30 }}>Or browse your NeOsense records (NeOse)</h1>
              <Link to={`${AppRoute.WEBAPP}?start=-2w`} style={{ width: '100%' }}>
                <Button type="primary" block style={{ height: 50, borderRadius: 5, marginBottom: 30 }}>
                  Go to records
                </Button>
              </Link>
            </Col>
            <Col></Col>
          </Row>
        </SectionPage>
        <SectionPage backgroundColor="transparent" boxShadow={false} paddingTop={10}>
          <Row justify="space-between" align="stretch" style={{ marginBottom: 10 }} gutter={[16, 0]}>
            <Col md={8} span={24}>
              <DataSourcesHome />
            </Col>
            <Col md={8} span={24}>
              <SavedSessionsHome />
            </Col>
            <Col md={8} span={24}>
              <SqliteHome />
            </Col>
          </Row>
        </SectionPage>
      </SectionPage>
    </>
  );
};
